import styled from "styled-components";

const MainWr = styled.div`
  .for-translate {
    height: 40vh;
    align-items: center;
  }
  .animate {
    margin: auto !important;
  }
`;
export default MainWr;
